import React from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { ErrorBoundary } from "app/ErrorBoundary/ErrorBoundaryDashboard";
import { Login } from "features/Login/Login";

const UnauthenticatedApp: React.FC = () => (
  <ErrorBoundary>
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  </ErrorBoundary>
);

export default UnauthenticatedApp;
